/**
 * @generated SignedSource<<b8205fd17d160f83d9477d28c4445a01>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OverviewSection_pageSection$data = {
  readonly anchorName: string;
  readonly detailPageLink: {
    readonly " $fragmentSpreads": FragmentRefs<"SimpleLink_simpleLink">;
  };
  readonly overviewSectionText: string;
  readonly title: string;
  readonly titleImageBackgroundUrl: string;
  readonly titleImageUrl: string;
  readonly " $fragmentType": "OverviewSection_pageSection";
};
export type OverviewSection_pageSection$key = {
  readonly " $data"?: OverviewSection_pageSection$data;
  readonly " $fragmentSpreads": FragmentRefs<"OverviewSection_pageSection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OverviewSection_pageSection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "titleImageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "titleImageBackgroundUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "anchorName",
      "storageKey": null
    },
    {
      "alias": "overviewSectionText",
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SimpleLink",
      "kind": "LinkedField",
      "name": "detailPageLink",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SimpleLink_simpleLink"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "OverviewSection",
  "abstractKey": null
};

(node as any).hash = "8c7837e8ab6af82961e32194c59a2187";

export default node;
